import { createContext, useContext, useEffect, useState } from "react";
import { api } from "../lib/api";

const AuthContext = createContext(null);
export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);

  useEffect(() => {
    if (!localStorage.getItem("dx_token")) return setUser(false);
    api.get("/auth/me").then((r) => setUser(r.data)).catch(() => {
      localStorage.removeItem("dx_token");
      setUser(false);
    });
  }, []);

  const finish = (data) => {
    localStorage.setItem("dx_token", data.token);
    setUser(data.user);
    return data.user;
  };
  const login = async (email, password) => finish((await api.post("/auth/login", { email, password })).data);
  const register = async (payload) => finish((await api.post("/auth/register", payload)).data);
  const logout = () => {
    localStorage.removeItem("dx_token");
    setUser(false);
  };

  return <AuthContext.Provider value={{ user, login, register, logout }}>{children}</AuthContext.Provider>;
};

export const homeFor = (role) => ({ staff: "/app/staff", employer: "/app/employer", admin: "/app/admin" }[role] || "/");
